import styled from 'styled-components';

export const WhiteContainer = styled.div`
	padding: 20px;
	margin-bottom: 20px;
	background: #fff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 10px #f4cfbe;
	border-radius: 20px;
	opacity: 1;
	max-width: 100%;
`;

export const WhiteContainerPurple = styled.div`
	padding: 20px;
	margin-bottom: 20px;
	background: #fff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 10px #bd88c6;
	border-radius: 20px;
	opacity: 1;
	max-width: 100%;
`;

export const BlueBorderWhiteContainer = styled.div`
	padding: 20px;
	margin-bottom: 20px;
	background: #fff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 10px #f4cfbe;
	border: 1px solid #bacce8;
	border-radius: 20px;
	opacity: 1;
	max-width: 100%;
`;

export const WhiteContainerSide = styled.div`
	padding: 20px;
	margin-bottom: 20px;
	margin-left: 20px;
	margin-right: 20px;
	margin-top: 8px;
	background: #fff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 10px #f4cfbe;
	border-radius: 20px;
	opacity: 1;
	max-width: 100%;
`;

export const NoPMContainer = styled.div`
	background: #fff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 10px #f4cfbe;
	border-radius: 20px;
	opacity: 1;
	max-width: 100%;
`;
